import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { useErrorContext } from '../../contexts/ErrorContext';
import {
  ErrorBoundary as ReactErrorBoundary,
  FallbackProps,
} from 'react-error-boundary';

const ErrorContainer = styled.div`
  margin: 20px;
  padding: 20px;
  border: 1px solid #e0a0a0;
  border-radius: 4px;
  background-color: #fff0f0;
  color: #d32f2f;
`;

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
  componentName?: string;
}

const ErrorFallback: React.FC<FallbackProps & { componentName?: string }> = ({
  error,
  resetErrorBoundary,
  componentName,
}) => (
  <ErrorContainer>
    <h2>Something went wrong in {componentName || 'this component'}.</h2>
    <details style={{ whiteSpace: 'pre-wrap' }}>
      <summary>Error Details</summary>
      <p>
        <strong>Error:</strong> {error.message}
      </p>
      <p>
        <strong>Stack:</strong> {error.stack}
      </p>
    </details>
    <button onClick={resetErrorBoundary} style={{ marginTop: '10px' }}>
      Try Again
    </button>
  </ErrorContainer>
);

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  children,
  fallback,
  componentName = 'unknown',
}) => {
  const errorContext = useErrorContext();

  const handleError = (error: Error, info: { componentStack: string }) => {
    errorContext?.addError?.({
      message: error.message,
      stack: error.stack,
      component: componentName,
      metadata: { componentStack: info.componentStack },
    });
  };

  return (
    <ReactErrorBoundary
      FallbackComponent={
        fallback
          ? () => <>{fallback}</>
          : (props) => (
              <ErrorFallback {...props} componentName={componentName} />
            )
      }
      //@ts-expect-error i will need to fix this
      onError={handleError}
    >
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
